import React from 'react';
import Link from './Link';

const LinkWrapper = (props) => {
  const {
    contentState,
    entityKey,
    string,
    children,
    setEditorLinkModalData,
    setEditorInformationLinkModalData,
    setEditorState,
    editorStateSelector,
    setEditorPhoneModalData,
  } = props;

  const { url } = contentState.getEntity(entityKey).getData();

  return (
    <Link
      children={children}
      string={string}
      url={url}
      setEditorPhoneModalData={setEditorPhoneModalData}
      setEditorLinkModalData={setEditorLinkModalData}
      setEditorInformationLinkModalData={setEditorInformationLinkModalData}
      setEditorState={setEditorState}
      editorStateSelector={editorStateSelector}
    />
  );
};

export default LinkWrapper;
